import httpClient from '../../api/httpClient'
import { mapState } from 'vuex'
import store from '../../store/store'
export default {
  data() {
    return {
      tenant: {}
    }
  },
  async mounted() {
    let response = await httpClient.get(
      `/tenantSettings/${this.userDecoded.TenantId}`
    )

    this.tenant = response.data
    var maxSpeed = this.tenant.maximumSpeed
    if (maxSpeed) {
      store.dispatch('history/changeMaxSpeed', maxSpeed)
    }
  },
  computed: {
    ...mapState('user', ['userDecoded']),
    mapType() {
      return this.tenant.mapType
    },
    useYellowPacketColor() {
      return this.tenant.useYellowPacketColor
    }
  }
}
